// This component uses IntersectionObserver and position: sticky
// to do scrolly. It only works on browsers that support those two features.

import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import range from "lodash/range";
import useResizeObserver from "../utils/useResizeObserver";
// import ExploreDataButton from "./ExploreDataButton.js";

// This function finds the intersection observer entry with the highest
// ratio. For example, if we have the following entries:
// [{ step: 0, ratio: 0.9 }, { step: 1, ratio: 0.1 }, { step: 2, ratio: 0 } ]
// The highest ratio is { step: 2, ratio: 0 }.
// The overall ratio is then 2 (2 + 0).
// Finally, the overall pct is calculated as:
// Math.min(2 + 0, 3 - 1) / (3 - 1), or
// 2 / 2 = 1 (2 being the number of steps).
// The function returns this * 100.

// const [isVertical, setIsVertical] = useState(false);

const getScrollProgress = (observerEntries) => {
  const maxStepProgress =
    observerEntries
      .filter((entry) => entry && entry.ratio > 0)
      .map((entry) => entry.step + entry.ratio)
      .sort((a, b) => a - b)
      .slice(-1)[0] || 0;

  const overallPct =
    Math.min(maxStepProgress, observerEntries.length - 1) /
    (observerEntries.length - 1);

  const currentStep =
    overallPct < 1 ? Math.trunc(maxStepProgress) : observerEntries.length - 2;

  const currentStepPct =
    overallPct < 1 ? maxStepProgress - Math.trunc(maxStepProgress) : 1;

  return { overallPct, currentStep, currentStepPct };
};

const DefaultStep = (props) => {
  const { index, stepAlignmentClass, data, width, height } = props;
  const { text } = data;
  // const thisRef = useRef(null);
  // const { width, height } = useResizeObserver(thisRef);

  console.log("test", width + ", " + height);

  return (
    <>
      {data.type === "head" ? (
        <div
          className="font--body font-xs-ns"
          style={{ height: "50vh" }}
          data-step={index}
        >
          <div
            className={
              width > height ? "header-box" : "header-box header-box-mobile"
            }
          >
            <div className="title">
              <span>장애, 테크로 채우다</span>
            </div>
            <div className="headline">
              <span>{text}</span>
            </div>
          </div>

          {/* <div className="test-width" ref={thisRef}></div> */}
        </div>
      ) : (
        // vh-100
        <div
          className="font--body font-xs-ns scrolly-text-box"
          data-step={index}
        >
          <p
            className={`bg-brown brad-2 color-white pt-sm pb-sm pl-md pr-md mt-0 mb-0
        ml-auto mr-auto box-shadow ${stepAlignmentClass} scrolly-text`}
            dangerouslySetInnerHTML={{
              __html: htmlDecode(text),
            }}
          />
        </div>
      )}
    </>
  );
};

function htmlDecode(input) {
  let ret = input.replace(/&gt;/g, ">");
  ret = ret.replace(/&lt;/g, "<");
  ret = ret.replace("″", '"');
  return ret;
}

const Scrolly = (props) => {
  const {
    onProgressHandler,
    stepAlignment,
    Step = DefaultStep,
    type,
    width,
    height,
  } = props;
  let { steps } = props;

  // Add a padding step. We need this to make sure the overallPct
  // doesn't go back down from 100% as we scroll down.
  // For more on this, see overallPct and comments in the render section.
  steps = steps.concat({ text: "" });

  // This holds the overall parent DOM element. We need it so
  // we can retrieve the steps DOM elements.
  const parentElementRef = useRef(null);

  // This array holds intersection observer entries
  // and their corresponding intersection ratios.
  // We'll use that when calculating the overall percentage.
  // e.g. [{step: 0, ratio: 0.5}, {step: 1, ratio: 0}...]
  const [observerEntries, setObserverEntries] = useState([
    ...Array(steps.length),
  ]);

  // On mount, initialize the IntersectionObserver.
  useEffect(() => {
    const options = {
      // Set the IntersectionObserver threshold. This might be too detailed.
      // If so, we might want to lower it and/or expose as a prop.
      threshold: range(0, 1, 0.01).concat(1),
    };

    // Create the IntersectionObserver and the corresponding callback.
    const observer = new IntersectionObserver((entries) => {
      // This callback fires every time a target intersects the observer.

      // For every entry,
      entries.forEach((entry) => {
        // checks if step elements have the proper attribute
        if (!entry.target.dataset?.step) {
          throw Error(
            "Scrolly: No data-step attribute found. Please add `data-step={index}` to your custom Step’s parent div."
          );
        }
        // update the corresponding observerEntries item.
        setObserverEntries((observerEntries) =>
          observerEntries.map((value, index) =>
            index === +entry.target.dataset.step
              ? {
                  step: +entry.target.dataset.step,
                  ratio: entry.intersectionRatio,
                }
              : value
          )
        );
      });
    }, options);

    // Find all the step DOM elements and make each of them
    // observe our intersection observer target (the viewport).
    const targets = parentElementRef.current.querySelectorAll("section > div");
    targets.forEach((target) => {
      observer.observe(target);
    });

    return () => {
      // When the component unmounts, make all targets stop
      // observing the viewport.
      targets.forEach((target) => {
        observer.unobserve(target);
      });
    };
  }, []);

  // When `observerEntries` changes, notify the sticky container.
  useEffect(() => {
    const scrollProgress = getScrollProgress(observerEntries);
    onProgressHandler(scrollProgress);
  }, [observerEntries, onProgressHandler]);

  const stepAlignmentClass = {
    left: "ml-10vw-ns",
    center: "",
    right: "mr-10vw-ns",
  }[stepAlignment];

  return (
    <>
      <div
        ref={parentElementRef}
        className="scrolly relative"
        // style={{ zIndex: type === "top-scrolly" ? -1 : 0 }}
      >
        <div className="sticky top-0 vh-100" style={{ zIndex: -1 }}>
          <div
            className="absolute w-100 h-100 of-cover op-center
            flex items-center justify-center"
            style={{ zIndex: -1 }}
          >
            {props.children}
          </div>
        </div>
        <section className="relative ">
          {/* Add a div for each step, and put the step's text in a p.
           * Observe we're skipping the last step, the empty one.
           */}
          {steps.slice(0, steps.length - 1).map((data, i) => {
            return (
              <Step
                stepAlignmentClass={stepAlignmentClass}
                key={i}
                index={i}
                data={data}
                className="scrolly-text"
                width={width}
                height={height}
              />
            );
          })}
          {/* Add an extra final step. Note it has height 1 pixel.
            * So why do we need it?
            *
            * Say we have two steps:
            * [{ step: 0 }, { step: 1 }]
            *
            * And say we've scrolled to the end of step 1:
            * [{ step: 0, ratio: 0 }, { step: 1, ratio: 1 }]
            *
            * At this point, the overallPct is 100.
            * (consult overallPct's documentation for more on this).
            *
            * If we continue scrolling, as step 1 scrolls up and out of
            * visibility, we'll get something like this:
            * [{ step: 0, ratio: 0 }, { step: 1, ratio: 0.9 }]
            *
            * At this point, the overallPct is 95.
            * Which means the video will scroll back a bit, as we scroll
            * down. This is not the desired behavior! We want the video
            * to stay at a 100% as we scroll all the way past this
            * component.
            *
            * Hence this final step. If we add it, we'll get this instead:
            * [{ step: 0, ratio: 0 }, { step: 1, ratio: 0.9 },
            *  { step: 2, ratio: 0.1 }]
            *
            * But because of the way overallPct clamps its pct,
            * it will return Math.min(2 + 0.1, 2) / 2, or 1.
            * After we * 100, that's 100%.

            * In other words:
            * this last 1-pixel step, in combination with
            * overallPct, ensures that as we scroll down, we don't
            * scrub the video back.
          */}
          <div data-step={steps.length - 1} style={{ height: 1 }} />
        </section>
      </div>
      {/* <ExploreDataButton></ExploreDataButton> */}
    </>
  );
};

Scrolly.propTypes = {
  /** An array of steps to scroll over */
  steps: PropTypes.array.isRequired,
  /** The horizontal alignment of the step's box. The text itself is left-aligned */
  stepAlignment: PropTypes.oneOf(["left", "center", "right"]),
  /** A callback that gets fired on scroll */
  onProgressHandler: PropTypes.func.isRequired,
  /** An optional custom Step component */
  Step: PropTypes.func,
};

Scrolly.defaultProps = {
  steps: [
    { text: "This is step 1" },
    { text: "This is step 2" },
    { text: "This is step 3" },
  ],
  stepAlignment: "center",
};

export default Scrolly;
